export const sidebarData = [


  {
    userId: "siteprojects",
    subMenu: null,
    name: "All Projects",
    svg: `<svg width="27" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path  d="M13.5 13V5M6.83333 15.6667V5M20.1667 18.3333V5M4.7 1H22.3C23.1487 1 23.9626 1.33714 24.5627 1.93726C25.1629 2.53737 25.5 3.35131 25.5 4.2V21.8C25.5 22.6487 25.1629 23.4626 24.5627 24.0627C23.9626 24.6629 23.1487 25 22.3 25H4.7C3.85131 25 3.03737 24.6629 2.43726 24.0627C1.83714 23.4626 1.5 22.6487 1.5 21.8V4.2C1.5 3.77977 1.58277 3.36365 1.74359 2.97541C1.9044 2.58717 2.14011 2.23441 2.43726 1.93726C3.03737 1.33714 3.85131 1 4.7 1Z" stroke="#707070" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
    svgfill: `
   <svg width="27" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path  d="M13.5 13V5M6.83333 15.6667V5M20.1667 18.3333V5M4.7 1H22.3C23.1487 1 23.9626 1.33714 24.5627 1.93726C25.1629 2.53737 25.5 3.35131 25.5 4.2V21.8C25.5 22.6487 25.1629 23.4626 24.5627 24.0627C23.9626 24.6629 23.1487 25 22.3 25H4.7C3.85131 25 3.03737 24.6629 2.43726 24.0627C1.83714 23.4626 1.5 22.6487 1.5 21.8V4.2C1.5 3.77977 1.58277 3.36365 1.74359 2.97541C1.9044 2.58717 2.14011 2.23441 2.43726 1.93726C3.03737 1.33714 3.85131 1 4.7 1Z" stroke="#2576BC"stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  },


];
